import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatcher_FloatingWindows_FocusWindow = new ThunderDispatcher('__onFocusFloatingWindow');
//# sourceMappingURL=focus-window.js.map